import React, {FunctionComponent, useMemo} from 'react';
import styles from './ClusterChart.module.css';
import {KeyedVisualisationData} from "../../models/visualisation-data.interface";
import ClusterGroup from "../cluster-group/ClusterGroup";
import {useWindowSize} from "../../utility-hooks/use-window-size";
import MobileClusterController from "../mobile-cluster-controller/MobileClusterController";

const ClusterChart: FunctionComponent<{ dataGroup: KeyedVisualisationData[] }> = (
  {
    dataGroup,
  }) => {

  const groups = useMemo(() => dataGroup.map(d => Object.entries(d)), [dataGroup]);
  const {windowWidth} = useWindowSize();
  const width = useMemo(() => windowWidth / groups[1].length, [groups, windowWidth]);

  return (
    <div className={styles.chartContainer}>
      {windowWidth > 480
        ? groups[1].map(([key, value], i) =>
          <div key={i}>
            <div>
              <ClusterGroup
                  dataGroup={[groups[0][i][1], value]}
                  width={width}
                  key={i}
                  isLast={groups[1].length - 1 === i}
              />
            </div>
            <h3 className={styles.title}>{key}</h3>
          </div>)
        : <MobileClusterController dataGroups={dataGroup} width={windowWidth}/>
      }
    </div>
  )
}

export default ClusterChart;
